module.exports = {
  painter: require('./painter'),
  getShape: require('./getShape')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/component/node_modules/@antv/g/lib/renderers/svg/index.js
// module id = 356
// module chunks = 0 1 2